import { configureStore } from '@reduxjs/toolkit';

import { combineReducers } from 'redux';

import alertNotificationsReducer from './alertNotifications';
import myMoneyReducer from './my-money';
import overlayReducer from './overlay';
import profileReducer from './profile';
import transactionsTranslationsReducer from './transactionsTranslations';

const reducers = combineReducers({
  profile: profileReducer,
  overlay: overlayReducer,
  alertNotifications: alertNotificationsReducer,
  transactionsTranslations: transactionsTranslationsReducer,
  myMoney: myMoneyReducer,
});

const store = configureStore({
  reducer: reducers,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredPaths: ['profile.balance', 'profile.reservedFunds', 'profile.phone'],
        ignoredActions: [
          'profile/clear',
          'profile/set',
          'profile/subtractBalance',
          'profile/refresh/fulfilled',
        ],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;

export default store;
